/* eslint-disable jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions */
import React, { Component } from 'react';
import {
  string,
  shape,
  arrayOf,
  bool,
  number,
} from 'prop-types';
import _ from 'lodash';
import { withRouter } from 'react-router';
import withApplicationConfig from 'containers/withApplicationConfig';
import withUserAgent from 'containers/withUserAgent';
import { getObjectFromStaticTextArray } from 'helpers/Utils';
import { Card, Button } from 'components/common';
import LoadingIndicator from 'components/common/LoadingIndicator';
import NewsLetterPanel, { staticTextKeys as newsletterPanelStaticTextKeys } from 'components/staticPage/NewsLetter/NewsLetterPanel';
import MissionStatement from 'components/staticPage/Banners/MissionStatement';
import FaqContextualContainer, { questionWithArrow } from 'components/FAQ/FaqContextualContainer';
import VerticalsList from 'components/Provider/VerticalsList/VerticalsList';
import ProvidersDescriptionPanel from './ProvidersDescriptionPanel';
import ProviderPane from './ProviderPane/ProviderPane';

import './ProviderResultsPage.scss';
import SeoTable from '../../../components/seo/SeoTable';

export const staticTextKeys = [
  'PROVIDERS_RESULT_PAGE_TITLE',
  'PROVIDERS_RESULT_PAGE_DESCRIPTION',
  'PROVIDERS_RESULT_PAGE_SHOW_MORE_RESULTS',
  ...newsletterPanelStaticTextKeys,
];

class ProviderResultsPage extends Component {
  constructor() {
    super();

    this.state = {
      isShowMore: false,
    };

    this.toggleIsShowMore = this.toggleIsShowMore.bind(this);
    this.getVerticals = this.getVerticals.bind(this);
  }

  getVerticals(filterPanel) {
    const { filterBy } = filterPanel;
    const list = _.find((filterBy || []), { queryParam: 'list' }) || {};
    const listOptions = list.options || [];
    const defaultSelection = _.get(list, 'defaultSelection[0]');

    // Props from withRouter
    const {
      match: { params },
      providerResultsPageRouteWithVertical,
      providerResultsPageRoute,
      defaultList,
    } = this.props;
    const { language, vertical } = params;
    return listOptions.map(({ name, value }) => ({
      name,
      value,
      href: name === defaultList
        ? _.template(providerResultsPageRoute)({ language })
        : _.template(providerResultsPageRouteWithVertical)({
          language,
          vertical: name,
        }),
      isSelected: vertical ? vertical.toLowerCase() === name : name === defaultSelection,
    }));
  }

  getProviders(fetchedProviders) {
    // Props from withRouter
    const {
      match: { params },
      providerProductPageRoute,
      resultsPageRouteWithProviderAlias,
      resultsPageRouteWithoutProviderAlias,
      language,
      mappings,
      defaultList,
    } = this.props;
    const { vertical } = params;
    const productVertical = _.findKey(mappings, { route: vertical });
    return (fetchedProviders || [])
      // Added this line because sometimes provider is just "null"
      .filter(provider => provider && provider.id)
      .map((provider) => {
        const mapping = mappings[productVertical] || {};
        return {
          ...provider,
          href: (vertical && vertical !== defaultList)
            ? _.template(
              mapping.isRouteSkipProviderAlias
                ? resultsPageRouteWithoutProviderAlias
                : resultsPageRouteWithProviderAlias
            )({
              language,
              vertical,
              alias: mapping.isRouteSkipProviderAlias
                ? ''
                : provider.alias,
            })
            : _.template(providerProductPageRoute)({
              language,
              alias: provider.alias,
            }),
        };
      });
  }

  toggleIsShowMore() {
    this.setState(({ isShowMore }) => ({
      isShowMore: !isShowMore,
    }));
  }

  render() {
    const {
      isShowMore,
    } = this.state;

    const {
      loading,
      subscribe,
      missionStatement,
      faqs,
      products: fetchedProviders,
      filterPanel = {},
      numberInitialResults: numInitResultsRaw,
      staticPageText = {},
      language,
      userAgent,
      localisation,
      seoTable,
    } = this.props;

    const numInitResults = (userAgent.isMobile && !userAgent.isTablet)
      ? Math.floor(numInitResultsRaw / 2)
      : numInitResultsRaw;

    const { staticText: staticTextArray } = staticPageText;
    const staticText = getObjectFromStaticTextArray(staticTextArray);

    const verticals = this.getVerticals(filterPanel);

    const providers = this.getProviders(fetchedProviders);
    const trimmedProviders = providers.slice(0, numInitResults) || [];

    return (
      <div className="providers-result-page">
        <ProvidersDescriptionPanel
          title={staticText.PROVIDERS_RESULT_PAGE_TITLE}
          description={staticText.PROVIDERS_RESULT_PAGE_DESCRIPTION}
        />
        <div className="providers-panel">
          <div className="container-wrapper">
            <VerticalsList verticals={verticals} />
            {loading
              ? <LoadingIndicator />
              : (
                <div className="provider-items">
                  <div className="row-wrapper">
                    {(isShowMore ? providers : trimmedProviders)
                      .map(provider => (
                        <div
                          className="provider-list-item-wrapper"
                          key={provider.id}
                        >
                          <ProviderPane {...provider} />
                        </div>
                      ))}
                  </div>
                  {providers.length > numInitResults && !isShowMore && (
                    <div className="row-wrapper">
                      <div
                        className="providers-show-more"
                        onClick={this.toggleIsShowMore}
                      >
                        <Card preserveShapeOnMobile>
                          <div className="providers-show-more-content">
                            <Button text>
                              {staticText.PROVIDERS_RESULT_PAGE_SHOW_MORE_RESULTS}
                            </Button>
                          </div>
                        </Card>
                      </div>
                    </div>
                  )}
                </div>
              )}
          </div>
        </div>
        { seoTable && <SeoTable {...seoTable} language={language} /> }
        {faqs && faqs.faqs && (
          <div className="faq-section">
            <div className="faq-container">
              <FaqContextualContainer
                title={faqs.heading}
                faqs={faqs}
                questionRender={questionWithArrow}
                viewAllCta={faqs.viewAllCta}
              />
            </div>
          </div>
        )}
        {missionStatement && <MissionStatement {...missionStatement} />}
        {subscribe
          && (
            <NewsLetterPanel
              {...subscribe}
              language={localisation[language]}
              staticText={staticText}
              page="provider"
            />
          )
        }
      </div>
    );
  }
}

ProviderResultsPage.defaultProps = {
  loading: false,
  subscribe: null,
  missionStatement: null,
  faqs: null,
  seoTable: null,
  products: [],
  staticPageText: {},
  numberInitialResults: 10,
  filterPanel: {},
  providerResultsPageRouteWithVertical: null,
  providerProductPageRoute: null,
  resultsPageRouteWithProviderAlias: null,
  resultsPageRouteWithoutProviderAlias: null,
  providerResultsPageRoute: null,
  localisation: {},
  mappings: {},
  userAgent: {},
  defaultList: undefined,
};

ProviderResultsPage.propTypes = {
  match: shape({}).isRequired,
  loading: bool,
  subscribe: shape({}),
  missionStatement: shape({}),
  faqs: shape({}),
  seoTable: shape({}),
  products: arrayOf(shape({})),
  filterPanel: shape({}),
  numberInitialResults: number,
  staticPageText: shape({}),
  providerResultsPageRouteWithVertical: string,
  providerProductPageRoute: string,
  resultsPageRouteWithProviderAlias: string,
  resultsPageRouteWithoutProviderAlias: string,
  providerResultsPageRoute: string,
  language: string.isRequired,
  localisation: shape({}),
  mappings: shape({}),
  userAgent: string,
  defaultList: string,
};

export default withRouter(withApplicationConfig(withUserAgent(ProviderResultsPage), ['languages', 'routes', 'providerContainer', 'verticals', 'providerResultsPage']));
